"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _html2canvas = _interopRequireDefault(require("html2canvas"));

var _jspdf = _interopRequireDefault(require("jspdf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 *
 * @param  selector = selector to grab
 * @param fileName = file name for saved pdf , exclude .pdf
 *
 */
var ConvertToPdf = function ConvertToPdf(_ref) {
  var selector = _ref.selector,
      fileName = _ref.fileName;
  (0, _html2canvas["default"])(document.querySelector(selector)).then(function (canvas) {
    var imgData = canvas.toDataURL('image/png');
    var imgWidth = 210;
    var pageHeight = 295;
    var imgHeight = canvas.height * imgWidth / canvas.width;
    var heightLeft = imgHeight;
    var pdf = new _jspdf["default"]('p', 'mm');
    var position = 0;
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(fileName + '.pdf');
  });
};

var _default = ConvertToPdf;
exports["default"] = _default;